import React from 'react'
import StyledH1Heading from '../../../common/components/styledH1Heading/StyledH1Heading'
import StyledLgText from '../../../common/components/styledLgText/StyledLgText'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'

const LandingSection = () => {
  return (
    <div className="h-full py-60 lg:py-40 w-[90%] lg:w-[80%]">
      <div className="flex flex-col items-center gap-3 lg:gap-5">
        <div className='text-center'>
          <StyledSmText fontColor="text-gray">WELCOME TO <b>HopeLedger</b></StyledSmText>
        </div>
        <div className='text-center'>
          <StyledH1Heading fontColor="text-gradient">A Decentralized Crowdfunding Platform</StyledH1Heading>
        </div>
        <div className='text-center md:w-[70%]'>
          <StyledLgText fontColor="text-white">HopeLedger is Pakistan's first decentralized crowdfunding platform on blockchain, ensuring transparency, security, and community-driven support for projects globally.</StyledLgText>
        </div>
      </div>
    </div>
  )
}

export default LandingSection
